import React, { useContext, useState } from 'react';
import {
  Grid,
  Typography,
} from '@material-ui/core';

import PropTypes from 'prop-types';

import AddButton from '../buttons/addButton';
import AddMembersDialog from '../modals/addMembersDialog';
import CustomSnackbar from '../feedback/customSnackbar';
import CarerInfo from './carerInfo';
import SpinnerLoading from '../feedback/spinnerLoading';

import { getEnrolment } from '../../utils/comms';

import translations from '../../languages/i18n';

import { SessionContext } from '../../utils/context';

export default function CarersSection({ userType, enrolmentData, title }) {
  const sessionContext = useContext(SessionContext);

  const [currentCarers, setCurrentCarers] = useState(enrolmentData.carers);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  const [showAddCarers, setShowAddCarers] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const obtainEnrolmentCarers = async () => {
    setShowLoading(true);
    const response = await getEnrolment(enrolmentData._id, sessionContext.userToken);
    setShowLoading(false);
    if (response.status === 200) { // Tenim llistat
      setCurrentCarers(response.data.enrolment.supervisedBy);
    } else if (response === 400) { // Error amb les dades
      console.log('Error 400');
    } else { // Login KO. Altres errors
      console.log(response);
    }
  };
  const manageFeedback = (fbType, fbMessage, reload) => {
    setFeedbackMessage(translations[`_${fbType}${fbMessage}`]);
    setFeedbackType(fbType);
    setShowFeedback(true);
    if (reload) obtainEnrolmentCarers();
  };

  const manageAddCarerAnswer = (reloadCarers) => {
    setShowAddCarers(false);
    if (reloadCarers) obtainEnrolmentCarers();
  };

  return (
    <React.Fragment>
      <SpinnerLoading show={showLoading} />
      <CustomSnackbar show={showFeedback} handleCloseFeedback={(show) => setShowFeedback(show)} type={feedbackType} message={(showFeedback && feedbackMessage) || ''} />
      {/* Pos showAddEvent && per evitar que s'executi AddEventDialog fins que no obro el AddEvent */}
      {showAddCarers && (
        <AddMembersDialog
          open={showAddCarers}
          title={translations['_addMembersDialogTitle']}
          type='carer'
          currentCarers={currentCarers}
          idEnrolment={enrolmentData._id}
          idProgram={enrolmentData.program._id}
          handleClose={(reloadCarers) => manageAddCarerAnswer(reloadCarers)}
          handleFeedback={(fbType, fbMessage) => manageFeedback(fbType, fbMessage, false)}
        />
      )}
      <Grid container justify='flex-start' spacing={2}>
        <Grid item xs={10}>
          <Typography variant='h6' component='div'>{title}</Typography>
        </Grid>
        {(currentCarers.length !== 0 && (
          currentCarers.map((carer) => (
            <Grid item xs={10} key={`grid${carer.clinician._id}`}>
              <CarerInfo
                key={carer.clinician._id}
                idEnrolment={enrolmentData._id}
                carerData={carer.clinician}
                handleFeedback={(fbType, fbMessage, reload) => manageFeedback(fbType, fbMessage, reload)}
              />
            </Grid>
          ))
        )) || (
          <Grid item xs={10}>
            <Typography variant='body1' component='div'>{translations['_emptyCarers']}</Typography>
          </Grid>
        )}
        <Grid item xs={10}>
          {/* Si el clínic es de tipus bàsic no pot afegir cuidadors */}
          {/* TODO: decidir què fer amb els altres tipus de clínics i amb l'usuari Admin */}
          {/* <AddButton disabled={userType === 'Basic'} handleClick={() => setShowAddCarers(true)} /> */}
          <AddButton disabled={userType === 'Basic'} handleClick={() => console.log('TO DO: gestió dels cuidadors')} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}

// Indica i controla els props que se han de passar al component
CarersSection.propTypes = {
  userType: PropTypes.string.isRequired,
  enrolmentData: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};
